import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { FranchiseIntranetUpgradeModel } from './franchise-intranet-upgrade.model';
import { FiFranchiseIntranetUpgradeListDataModel } from './franchise-intranet-upgrade-list/franchise-intranet-upgrade-list-data.model';
import { UpcomingUpgradeStatus } from '@fi-app/franchise-intranet-upgrade/franchise-intranet-upgrade-upcoming-status';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Injectable()
export class FranchiseIntranetUpgradeService {
    UpgradeVersionType: { MinorUpgrade: { Id: number; TextId: string }; MajorUpgrade: { Id: number; TextId: string } };

    constructor(
        private fiBackend: FiBackendService,
        private fiFormatDateService: FiFormatDateService,
    ) {
        this.UpgradeVersionType = FranchiseIntranetUpgradeModel.UpgradeVersionType;
    }

    getFranchiseIntranetUpgradeInstance() {
        return new FranchiseIntranetUpgradeModel(this.fiFormatDateService);
    }

    GetFranchiseIntranetUpgrade(id) {
        const promise = new Promise<FranchiseIntranetUpgradeModel>((resolve, reject) => {
            this.fiBackend.fetchData(`Custom/UpgradeLog/GetFranchiseIntranetUpgrade/${id}`).then((data) => {
                const result = new FranchiseIntranetUpgradeModel(this.fiFormatDateService);
                result.Initialize(data, this.fiFormatDateService);
                resolve(result);
            }, reject);
        });
        return promise;
    }

    /* //todo not used
        IsUpcomingUpgradeAvailable()
        {
            return $http.get(GenerateUrl("Custom/UpgradeLog/IsUpcomingUpgradeAvailable"));
        };
    */

    GetFranchiseIntranetUpgrades(franchiseIntranetUpgradesParameterApiModel) {
        return this.fiBackend.fetchDataPost<FiFranchiseIntranetUpgradeListDataModel[]>(
            'Custom/UpgradeLog/GetFranchiseIntranetUpgrades',
            franchiseIntranetUpgradesParameterApiModel,
        );
    }

    GetFranchiseIntranetUpgradesCount(franchiseIntranetUpgradesParameterApiModel) {
        return this.fiBackend.fetchDataPost(
            'Custom/UpgradeLog/GetFranchiseIntranetUpgradesCount',
            franchiseIntranetUpgradesParameterApiModel,
        );
    }

    SaveFranchiseIntranetUpgrade(upgradeLogEntryApiModel: FranchiseIntranetUpgradeModel) {
        return this.fiBackend.fetchDataPost('Custom/UpgradeLog/SaveUpgradeLog', upgradeLogEntryApiModel);
    }

    GetUpcomingUpgradeStatus() {
        return this.fiBackend.fetchData<UpcomingUpgradeStatus>('Custom/UpgradeLog/GetUpcomingUpgradeStatus');
    }
}
